<template>
<div :class="{'pp-album-grid':1, 'pp-album-grid--mobile-horizontal': mobileHorizontal }"
     :style="{ 'max-height': maxRows ? (($root.view == 'mobile' ? 212 : 230) * maxRows) + 'px' : '' }">
    <div v-for="item in items" class="pp-album-grid__item">
        <img v-if="item.realArtwork" :src="item.artwork" class="pp-album-grid__item__artwork">
        <div v-if="!item.realArtwork" class="pp-album-grid__item__artwork pp-album-grid__item__artwork--placeholder pp-album-grid__item__artwork--placeholder-exclusive">
            Pristine Classical Exclusive
        </div>

        <div class="pp-album-grid__item__title">
            <div>{{ item.title }}</div>
        </div>
        <div class="pp-album-grid__hover-actions">
            <div @click="playTrack(item)" class="pp-album-grid__hover-action">
                <i class="fa fa-fw fa-play"></i>
            </div>
            <!--
                <div @click="playTrackNext(item)" class="pp-album-grid__hover-action pp-album-grid__hover-action--text">
                    Play Next
                </div>
            -->
            <div @click="addToQueue(item)" class="pp-album-grid__hover-action pp-album-grid__hover-action--text">
                Add to queue
            </div>
        </div>
    </div>
    <loading-indicator v-if="paginating"></loading-indicator>
</div>
</template>

<script>
import Ellipsis from 'ftellipsis';
import LoadingIndicator from './LoadingIndicator.vue';
import EventBus from '../EventBus.js'

export default {
    name: 'exclusive-grid',
    components: {
        LoadingIndicator
    },
    data() {
        return {
            titleEllipsis: [],
        };
    },
    props: {
        items: Array,
        maxRows: Number,
        mobileHorizontal: Boolean,
        canPaginate: Boolean,
        paginating: Boolean,
        reachedEnd: Boolean
    },
    computed: {
        tracks() {
            var tracks = [];
            for (let item of this.items) {
                tracks.push(item.tracks[0]);
            }
            return tracks;
        }
    },
    methods: {
        loadMore(items) {
            for (var item of items) {
                this.items.push(item);
            }
            this.getTitleElements();
            this.onResize();
        },

        getTitleElements() {
            this.titleEllipsis = [];
            let elements = this.$el.querySelectorAll('.pp-album-grid__item__title');
            for (let element of elements) {
                var ellip = new Ellipsis(element);
                ellip.calc();
                ellip.set();

                this.titleEllipsis.push(ellip);
            }
        },

        onResize() {
            for (let ellip of this.titleEllipsis) {
                ellip.calc();
                ellip.set();
            }
        },

        playTrack(item) {
            var track = item.tracks[0];
            track.album = item;
            EventBus.emit('core.track.play', {
                track: track,
                context: this.tracks,
                mode: null
            });
        },

        playTrackNext(item) {
            EventBus.emit('core.queue.addTrack', {
                track: item.tracks[0],
                next: false
            });
        },

        addToQueue(item) {
            EventBus.emit('core.queue.addTrack', {
                track: item.tracks[0],
                next: false
            });
        }
    },
    mounted() {
        this.getTitleElements();
        window.addEventListener('resize', () => this.onResize());

        EventBus.on('navigation.scrolling', (e) => {
            if (this.canPaginate && !this.reachedEnd && !this.paginating && e.data.fromBottom < 300) {
                this.$emit('paginate');
            }
        })
    }
};
</script>



// WEBPACK FOOTER //
// ExclusiveGrid.vue?efaf733a